export const OPTIONS = {
  CREATE_SITE: 'CREATE_SITE',
  CREATE_EMAIL: 'CREATE_EMAIL',
  MARKETING_TIPS: 'MARKETING_TIPS',
  SUPPORT: 'SUPPORT',
  DOMAIN_PURCHASE: 'DOMAIN_PURCHASE',
  MORE: 'MORE',
  CONFIGURE_DOMAIN: 'CONFIGURE_DOMAIN',
  CHECK_ACCOUNT: 'CHECK_ACCOUNT',
  CREATE_POSTS: 'CREATE_POSTS',
  CONTRACT_PRODUCT: 'CONTRACT_PRODUCT',
};
